import { findIndex, head } from 'lodash'
import SimpleMDE from 'simplemde'
import 'simplemde/dist/simplemde.min.css'
import { mapGetters, mapActions } from 'vuex'
import ls from 'local-storage'
// import { copyText } from 'src/helpers'
import { getAllTags, addTag } from 'src/api/tags'

export default {
  data () {
    let validatorType = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Bạn chưa chọn loại bài viết'))
      } else {
        callback()
      }
    }
    let validatorCategory = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Bạn chưa chọn danh mục bài viết'))
      } else {
        callback()
      }
    }
    return {
      localBlog: {
        title: '',
        teaser: '',
        type: '',
        category_id: '',
        content: '',
        active: 0,
        tags: [],
        hot: true,
        show_on_shop: true,
        show_on_landing: true
      },
      rules: {
        title: [
          {required: true, message: 'Bạn chưa nhập tiêu đề', trigger: 'change'},
          {max: 255, message: 'Tiêu đề phải nhỏ hơn 255 ký tự', trigger: 'change'}
        ],
        teaser: [
          {required: true, message: 'Bạn chưa nhập nội dung tóm tắt', trigger: 'change'},
          {max: 255, message: 'Nội dung tóm tắt phải nhỏ hơn 255 ký tự', trigger: 'change'}
        ],
        category_id: [
          // {required: true, message: 'Bạn chưa chọn danh mục bài viết', trigger: 'change'}
          {validator: validatorCategory, trigger: 'change'}
        ],
        type: [
          // {required: true, message: 'Bạn chưa chọn loại bài viết', trigger: 'change'}
          {validator: validatorType, trigger: 'change'}
        ],
        content: [
          {required: true, message: 'Bạn chưa nhập nội dung', trigger: 'change'}
        ]
      },
      simplemde: null,
      uploadImageUrl: process.env.API_URI + '/blogs/images',
      uploadHeader: {},
      image: {},
      imageContent: {},
      suggettionTag: {},
      listTags: [],
      fetchTag: false,
      selectedTags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  computed: {
    ...mapGetters('category', ['categories']),
    ...mapGetters('blog', ['blogHelpers'])
  },
  methods: {
    ...mapActions('category', ['getToTreeCategory']),
    ...mapActions('blog', ['getBlogHelpers']),
    newBlog () {
      this.localBlog = {
        title: '',
        teaser: '',
        type: '',
        category_id: '',
        content: '',
        active: 0,
        tags: [],
        hot: true,
        show_on_shop: true,
        show_on_landing: true
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    },
    handleImageUpload (res, file) {
      if (res.code) {
        this.image = res.data
        this.localBlog.image = res.data.name
      }
    },
    handleImageContentUpload (res, file) {
      if (res.code) {
        this.imageContent = res.data
        // copyText(this.imageContent.path)
      }
    },
    selectTag (q) {
      if (q) {
        this.fetchTag = true
        getAllTags({limit: 10, q: q}).then(response => {
          if (response.code === 200) {
            this.listTags = response.data
            this.fetchTag = false
          }
        })
      }
    },
    selectSuggettionTag () {
      if (this.localBlog.tags.indexOf(this.suggettionTag.id) === -1) {
        this.localBlog.tags.push(this.suggettionTag.id)
      }
      if (findIndex(this.selectedTags, {id: this.suggettionTag.id}) === -1) {
        this.selectedTags.push(this.suggettionTag)
      }
      this.listAdmins = []
    },
    removeTag (tag) {
      this.selectedTags.splice(findIndex(this.selectedTags, tag), 1)
      this.localBlog.tags.splice(this.localBlog.tags.indexOf(tag.id), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        addTag({tag: inputValue}).then(response => {
          switch (response.code) {
            case 200:
              this.selectedTags.push({id: response.data.id, tag: response.data.tag})
              this.localBlog.tags.push(response.data.id)
              this.inputVisible = false
              this.inputValue = ''
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              break
            default:
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: 'Thêm tag thất bại',
                type: 'warning'
              })
          }
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    getCategories () {
      this.localBlog.category_id = ''
      this.getToTreeCategory({limit: -1, type: this.localBlog.type})
    }
  },
  watch: {
    localBlog: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  },
  mounted () {
    this.uploadHeader.Authorization = `Bearer ${ls.get('authen').access_token}`
    this.newBlog()
    this.simplemde = new SimpleMDE({
      element: document.getElementsByName('content')[0],
      lineWrapping: false,
    })
    if (!Object.keys(this.blogHelpers).length) {
      this.getBlogHelpers()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/blog/mixins/index.js